export const list = [
  {
    id: '1',
    title: '公式サイト',
    url: 'https://www.theckb.com/',
    linkList: [
      {
        label: '輸入記事',
        url: 'https://www.theckb.com/archive/'
      },
      {
        label: '新着情報',
        url: 'https://www.theckb.com/news/'
      },
      {
        label: 'サンプルショールーム',
        url: 'https://www.theckb.com/company/showroom'
      }
    ]
  },
  {
    id: '2',
    title: 'システム案内',
    url: 'https://www.theckb.com/system/',
    linkList: [
      {
        label: 'B2Bモード',
        url: 'https://www.theckb.com/system/b2b'
      },
      {
        label: 'D2Cモード',
        url: 'https://www.theckb.com/system/d2c'
      }
    ]
  },
  {
    id: '3',
    title: '仕入れ・OEM・ ODM',
    url: 'https://www.theckb.com/merchandise/',
    linkList: [
      {
        label: '既製品仕入れ',
        url: 'https://www.theckb.com/merchandise/purchase'
      },
      {
        label: 'OEM ・ODM生産支援',
        url: 'https://www.theckb.com/merchandise/oemodm'
      }
    ]
  },
  {
    id: '4',
    title: '仕入れ支援サービス',
    url: 'https://www.theckb.com/service/',
    linkList: [
      {
        label: '検品サービス',
        url: 'https://www.theckb.com/service/inspection'
      },
      {
        label: '物流サービス',
        url: 'https://www.theckb.com/service/logistics'
      },
      {
        label: 'アテンドサービス',
        url: 'https://www.theckb.com/service/attend'
      }
    ]
  },
  {
    id: '5',
    title: '料金プラン',
    url: 'https://www.theckb.com/price/',
    linkList: [
      {
        label: 'B2B料金表',
        url: 'https://www.theckb.com/price/plan-b2b'
      },
      {
        label: 'D2C料金表',
        url: 'https://www.theckb.com/price/plan-d2c'
      },
      {
        label: '国際送料',
        url: 'https://www.theckb.com/price/shipping'
      }
    ]
  },
  {
    id: '7',
    title: 'ご利用ガイド',
    url: 'https://www.theckb.com/guide/',
    linkList: [
      {
        label: 'ご利用の流れ',
        url: 'https://www.theckb.com/guide/flow'
      },
      {
        label: 'よくある質問',
        url: 'https://www.theckb.com/guide/faq'
      }, {
        label: '免费注册2',
        url: 'https://s.theckb.com/signup'
      },
      {
        label: '询问',
        url: 'https://www.theckb.com/contact/'
      }
    ]
  }
]
export const krList = [
  // {
  //   id: '1',
  //   title: '什么是THE CKB',
  //   url: 'https://www.theckbkorea.com/',
  //   linkList: [
  //     {
  //       label: '费率计划',
  //       url: 'https://www.theckbkorea.com/about-1-3'
  //     }
  //   ]
  // },
  // {
  //   id: '2',
  //   title: '代购服务',
  //   url: 'https://www.theckbkorea.com/blog',
  //   linkList: [
  //   ]
  // },
  // {
  //   id: '3',
  //   title: '检验服务',
  //   url: 'https://www.theckbkorea.com/about-1',
  //   linkList: [
  //   ]
  // },
  // {
  //   id: '4',
  //   title: '物流服务',
  //   url: 'https://www.theckbkorea.com/about-1-1',
  //   linkList: [
  //   ]
  // },
  // {
  //   id: '5',
  //   title: '促销服务',
  //   url: 'https://www.theckbkorea.com/about-1-2',
  //   linkList: [
  //   ]
  // },
  {
    id: '6',
    title: '库存系统',
    url: 'https://s.theckb.com/ko/hub/ec',
    linkList: [
      {
        label: '无库存系统',
        url: 'https://s.theckb.com/ko/hub/ec'
      }
    ]
  }
]
export const enList = [
  {
    id: '1',
    title: '什么是THE CKB',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '最新情報',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '费率计划',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '计划诊断',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '国际航运',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '2',
    title: '代购服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 购买现有产品',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- OEM・ODM',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- FBA直送',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '3',
    title: '检验服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 检查',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 维修',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '4',
    title: '物流服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 国际运输',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 仓库储存',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '5',
    title: '促销服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 翻译',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 照片',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 导入文章',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '6',
    title: '系统',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 库存系统',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 无库存系统',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  }
]
